import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'path',
      d: 'M-6.5,0h1v0.5h-1zM6,0h0.5v0.5h-0.5zM-6.5,0.5h7v0.5h-7zM4,0.5h2v0.5h-2zM-5,1h11v0.5h-11z',
    },
    {
      paint: 'epicMarble',
      d: 'M0,-6.5h0.5v0.5h-0.5zM-0.5,-5.5h0.5v2h-0.5zM-3.5,-5h0.5v0.5h-0.5zM3.5,-4.5h0.5v2h-0.5zM-3.5,-4h0.5v0.5h-0.5zM0.5,-4h0.5v0.5h-0.5zM3.5,-2.5h1v0.5h-1zM-3.5,-2h0.5v0.5h-0.5zM0.5,-2h0.5v0.5h-0.5zM4,-2h1v0.5h-1zM-3,-1.5h0.5v0.5h-0.5zM-2,-1.5h0.5v0.5h-0.5zM4,-1.5h1.5v1h-1.5zM-6,-1h1.5v0.5h-1.5zM-6,-0.5h4.5v0.5h-4.5zM4,-0.5h2v0.5h-2zM-5,0h10.5v0.5h-10.5z',
    },
    { paint: 'water', d: 'M-5,-1.5h0.5v0.5h-0.5zM-4,-1h8v0.5h-8zM-1,-0.5h4v0.5h-4z' },
    {
      paint: 'church',
      d: 'M-0.5,-6.5h0.5v0.5h-0.5zM-1,-6h1v0.5h-1zM-1.5,-5.5h1v0.5h-1zM-4,-5h0.5v0.5h-0.5zM-2,-5h1.5v0.5h-1.5zM2.5,-5h1.5v0.5h-1.5zM-4.5,-4.5h1.5v0.5h-1.5zM-2.5,-4.5h2v0.5h-2zM2,-4.5h1.5v0.5h-1.5zM-5,-4h1.5v0.5h-1.5zM-3,-4h2.5v0.5h-2.5zM1.5,-4h2v0.5h-2zM-5.5,-3.5h2v1h-2zM-3,-3.5h3v1.5h-3zM1,-3.5h2.5v1.5h-2.5zM-6,-2.5h2.5v1h-2.5zM-3,-2h3.5v0.5h-3.5zM1,-2h3v0.5h-3zM-6,-1.5h1v0.5h-1zM-0.5,-1.5h4.5v0.5h-4.5z',
    },
    {
      paint: 'wallShade',
      d: 'M0,-6h0.5v2.5h-0.5zM-3.5,-3.5h0.5v1.5h-0.5zM0,-3.5h1v1.5h-1zM-2.5,-1.5h0.5v0.5h-0.5zM-4.5,-1h0.5v0.5h-0.5zM-6.5,-0.5h0.5v0.5h-0.5zM-1.5,-0.5h0.5v0.5h-0.5zM3,-0.5h1v0.5h-1zM-5.5,0h0.5v0.5h-0.5zM5.5,0h0.5v0.5h-0.5zM0.5,0.5h3.5v0.5h-3.5z',
    },
    {
      paint: 'epicCrystal',
      d: 'M-4.5,-1.5h1.5v0.5h-1.5zM-1.5,-1.5h1v0.5h-1zM-3.5,1.5h7v0.5h-7zM-3,2h6v0.5h-6z',
    },
  ],
  pixels: 300,
};
export const sprites: readonly PixelSprite[] = [variant0];
